export default __webpack_public_path__ + "static/media/default-billboard.7cb19094.jpeg";